
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://www.srf.ch/news/panorama/endlich-ruhe-im-schlafzimmer-schnarchstopp-gadgets-versprechen-viel-und-halten-wenig"
      }}>{`srf.ch`}</a>{`
Das grosse Buch vom Schlaf, Prof. Dr. med Matthew Walker
`}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/sonntagszeitung/die-macht-der-nacht/story/19121184"
      }}>{`tagesanzeiger.ch`}</a>{`
`}<a parentName="p" {...{
        "href": "https://www.thecut.com/2014/08/how-to-get-through-a-workday-on-no-sleep.html"
      }}>{`thecut.com`}</a>{`
SoZ, 14.10.2018, «Kein Handy, kein TV und kein Essen im Bett», Seite 25
`}<a parentName="p" {...{
        "href": "https://www.navigator-medizin.de/schlaf-und-schlafstoerungen/10-tipps-gegen-schlafprobleme.html"
      }}>{`navigator-medizin.de`}</a>{`
`}<a parentName="p" {...{
        "href": "https://www.navigator-medizin.de/schlaf-und-schlafstoerungen/die-wichtigsten-fragen-und-antworten-zu-schlafmitteln/grundlagen-der-schlafmittel-therapie/709-was-sind-typische-entzugssymptome-beim-absetzen-von-schlafmitteln.html"
      }}>{`navigator-medizin.de`}</a>{`
`}<a parentName="p" {...{
        "href": "https://www.bbc.com/news/magazine-16964783"
      }}>{`bbc.com`}</a>{`
`}<a parentName="p" {...{
        "href": "https://schlafmedizin.de"
      }}>{`schlafmedizin.de`}</a>{`
`}<a parentName="p" {...{
        "href": "https://welt.de"
      }}>{`welt.de`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;